// extracted by mini-css-extract-plugin
export var childrenContainer = "_dp-0";
export var virtualScrollArea = "_dp-1";